import i18n from "i18next";
import { initReactI18next, } from "react-i18next";

import ky from "./translation/ky.json";
import ru from "./translation/ru.json";
import en from "./translation/en.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  ky: { translation: ky, },
  ru: { translation: ru, },
  en: { translation: en, },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("lang") || "ky", // язык из localStorage, иначе кыргызский по умолчанию
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    fallbackLng: "ky",
    interpolation: { escapeValue: false, },
  });

export default i18n;
